import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root',
})
export class NativeStorageService {
  constructor(private router: Router) {}

  /**
   * @description Stores value in Capacitor Preferences
   * @param key Key for the object
   * @param obj Object to store
   * @returns Promise resolve/reject
   **/
  public storeOffline(key: string, obj: unknown): Promise<number> {
    return new Promise((resolve, reject) => {
      Preferences.set({ key: key, value: JSON.stringify(obj) }).then(
        () => resolve(0),
        (error) => reject(error),
      );
    });
  }

  public removeOffline(key: string): Promise<number> {
    return new Promise((resolve, reject) => {
      Preferences.remove({ key: key }).then(
        () => resolve(0),
        (error) => reject(error),
      );
    });
  }

  public getOffline(key: string): Promise<any> {
    return new Promise((resolve, reject) => {
      Preferences.get({ key: key }).then(
        (result) => {
          if (result.value === null) {
            reject({ code: 2, message: 'Item not found' });
          } else {
            try {
              resolve(JSON.parse(result.value));
            } catch (_e) {
              resolve(result.value);
            }
          }
        },
        (error) => reject(error),
      );
    });
  }

  public logout() {
    Preferences.clear();
    this.router.navigateByUrl('/');
  }
}
